<template>
  <div class="neogreen-footer">
    <div class="fotter-box">
      <div class="title">
        <div class="contact">Contact Information</div>
        <!-- <div class="phone">00852+48132067</div> -->
        <div class="phone">soumyajit@neogreenagriculturellp.com</div>
      </div>
      <div class="work">
        <img src="../assets/work.png" alt="">
        <p>OPEN DAILY</p>
        <p>10:00 AM - 8:00 PM</p>
      </div>
    </div>
    <div class="fotter-info">
      <div class="tel">
        <p>Contact Information</p>
        <span>Flat No. 402, Rosewood Apartments, Banjara Hills Road No. 12, Hyderabad, Telangana 500034, India</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fotter",
  data() {
    return {
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.neogreen-footer {
  padding: 80px 342px;
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  background: #1D1C1C;

  .fotter-box {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .title {
      text-align: left;

      .contact {
        margin-bottom: 20px;
        font-size: 40px;
        font-family: Arial, Arial;
        font-weight: 900;
        color: #FFFFFF;
      }

      .phone {
        margin-bottom: 16px;
        font-size: 32px;
        font-family: Arial, Arial;
        font-weight: normal;
        color: #FFFFFF;
      }
    }

    .work {
      width: 550px;
      height: 200px;
      background: #3B54EA;

      img {
        width: 50px;
        height: 50px;
        margin: 38px 0 16px 42px;
      }

      p {
        margin-left: 42px;
        font-size: 32px;
        font-family: Arial, Arial;
        font-weight: normal;
        color: #FFFFFF;
      }
    }
  }

  .fotter-info {
    margin-top: 84px;

    .tel {
      margin-right: 80px;

      p {
        margin-bottom: 20px;
        font-size: 32px;
        font-family: Arial, Arial;
        font-weight: normal;
        color: #FFFFFF;
      }

      span {
        font-size: 24px;
        font-family: ArialMT;
        color: #FFFFFF;
        line-height: 28px;
      }
    }
  }
}
</style>
